import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "@/components/ScrollToTop";
import Index from "./pages/Index";
import Contato from "./pages/Contato";
import DiagnosticoPatrimonial from "./pages/DiagnosticoPatrimonial";
import Obrigado from "./pages/Obrigado";
import ObrigadoAlt from "./pages/ObrigadoAlt";
import Parceiros from "./pages/Parceiros";
import ParceirosObrigado from "./pages/ParceirosObrigado";
import ParceirosV2 from "./pages/ParceirosV2";
import Assessores from "./pages/Assessores";
import AssessoresV2 from "./pages/AssessoresV2";
import Selecao from "./pages/Selecao";
import SelecaoObrigado from "./pages/SelecaoObrigado";
import Evento from "./pages/Evento";
import EventoAplicar from "./pages/EventoAplicar";
import EventoObrigado from "./pages/EventoObrigado";
import ParceiroCadastro from "./pages/ParceiroCadastro";
import ParceiroCadastroObrigado from "./pages/ParceiroCadastroObrigado";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <ScrollToTop />
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/diagnostico-patrimonial" element={<DiagnosticoPatrimonial />} />
          <Route path="/obrigado" element={<Obrigado />} />
          <Route path="/obrigado-alt" element={<ObrigadoAlt />} />
          <Route path="/parceiros" element={<Parceiros />} />
          <Route path="/parceiros/obrigado" element={<ParceirosObrigado />} />
          <Route path="/parceiros-v2" element={<ParceirosV2 />} />
          <Route path="/assessores" element={<Assessores />} />
          <Route path="/assessores-v2" element={<AssessoresV2 />} />
          <Route path="/selecao" element={<Selecao />} />
          <Route path="/selecao/obrigado" element={<SelecaoObrigado />} />
          <Route path="/evento" element={<Evento />} />
          <Route path="/evento/aplicar" element={<EventoAplicar />} />
          <Route path="/evento/obrigado" element={<EventoObrigado />} />
          <Route path="/parceiro/cadastro" element={<ParceiroCadastro />} />
          <Route
            path="/parceiro/cadastro/obrigado"
            element={<ParceiroCadastroObrigado />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </TooltipProvider>
    </BrowserRouter>
  </QueryClientProvider>
);

export default App;
